import axios from 'axios';
import { fromJS } from 'immutable';
import moment from 'moment';
import { dispatch, registerHandler } from 'nike-re-framejs';

import { catcher } from '@/_http/utils';
import { getUrl } from '@/common/oldMobile';
import { defaultMiddlewares } from '@/common/util';

let context = {};
export { context };

export function fetchProfile() {
    return axios
        .get(getUrl('PROFIL_API'))
        .then(json => dispatch(['myprofile.profileDataFetched', json]))
        .catch(catcher.swallow);
}

registerHandler('myprofile.profileDataFetched', defaultMiddlewares, (db, [data]) =>
    db
        .setIn(['myprofile', 'profile', 'fetched'], fromJS(data.profile))
        // radio button vie pracovat len so stringami :(
        // ak suhlas_MKT==null, tvarime sa ze suhlas mame
        .updateIn(['myprofile', 'profile', 'fetched', 'suhlas_MKT'], old => (old === 0 ? '0' : '1'))
        .setIn(['account', 'userData', 'marketingAgreement'], data.profile.suhlas_MKT)
        .setIn(['myprofile', 'profile', 'grid'], fromJS(data.profileGrid).set('time', new Date().getTime()))
);

registerHandler('myprofile.setGridPosition', defaultMiddlewares, (db, [gridPosition]) =>
    db.setIn(['myprofile', 'profile', 'grid', 'gridPosition'], gridPosition)
);

function deviceSort(d1, d2) {
    const date1 = moment(d1.lastUsed);
    const date2 = moment(d2.lastUsed);
    if (date1.isAfter(date2)) {
        return -1;
    }
    if (date1.isBefore(date2)) {
        return 1;
    }
    return 0;
}

export function fetchDevices(db) {
    axios
        .get(getUrl('USER_DEVICES_LIST'))
        .then(devices => {
            const sortedDevices = devices ? devices.sort(deviceSort) : [];
            sortedDevices.map(d => {
                d.lastUsed = lastUsed(d);
                return d;
            });
            dispatch(['commit-update', db => db.setIn(['myprofile', 'devices'], fromJS(sortedDevices))]);
        })
        .finally(() => {
            dispatch(['commit-update', db => db.removeIn(['myprofile', 'loading', 'devices'])]);
        });

    return db.setIn(['myprofile', 'loading', 'devices'], true);
}

export const unpairDevices = unpairTokens => db => {
    axios.post(getUrl('USER_DEVICES_UNPAIR'), unpairTokens).finally(() => dispatch(fetchDevices));
    return db.setIn(['myprofile', 'loading', 'devices'], true);
};

function lastUsed({ lastUsed }) {
    const i = lastUsed.indexOf('[');
    return i > -1 ? lastUsed.substring(0, i) : lastUsed;
}

export function doSendGridCardRequest(gridCardSendSuccess, token2Fa) {
    return axios
        .post(
            '/api/customer/grid-card-change',
            { token2Fa: token2Fa },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(() => gridCardSendSuccess());
}
